import { ContactType } from "../domain/contact-type";

const Contact = ({ contact }) => {
    const { link, iconPath } = ContactType[contact.serviceType]
    const onClickListener = () => {
        if (link) window.location.href = link(contact.content)
    }

    return (
        <>
            <div className="content-wrapper" onClick={onClickListener}>
                <img src={`${iconPath}`} className="contact-icon" alt={contact.title + "정보"} />
                <div className="desc-wrapper">
                    <div className="service">{contact.title}</div>
                    <div className="contact-addr">{contact.content}</div>
                </div>
                <svg className="arrow-right" width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L9 9.5L1 18" stroke="#C8C8C8" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </>
    )
}

export default Contact;
